import { Box } from '@cbhq/cds-web/layout';
import { HStack } from '@cbhq/cds-web/layout/HStack';
import { VStack } from '@cbhq/cds-web/layout/VStack';
import { Avatar } from '@cbhq/cds-web/media/Avatar';
import { TextHeadline } from '@cbhq/cds-web/typography';
import { TextLegal } from '@cbhq/cds-web/typography/TextLegal';

import { useProfileInfo } from '../providers/ProfileMenuV2Provider';

import { ManageAccountCTA } from './ManageAccountCTA';

export function ProfileHeaderContent() {
  const { email, name, avatarUrl } = useProfileInfo();

  return (
    <HStack paddingY={1} paddingX={2} gap={2}>
      <Box paddingTop={1}>
        <Avatar src={avatarUrl} alt={name} name={name} colorScheme="teal" size="l" selected />
      </Box>
      <VStack className="sensitive-data">
        {name && (
          <TextHeadline as="p" display="block">
            {name}
          </TextHeadline>
        )}
        {email && (
          <TextLegal as="p" overflow="break" numberOfLines={1} display="block">
            {email}
          </TextLegal>
        )}
        <ManageAccountCTA />
      </VStack>
    </HStack>
  );
}
